var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"modal-alert","title":_vm.$t('portal.page-title.modal.warning'),"centered":"","ok-only":""},on:{"ok":_vm.onOk}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }